import { createContext } from "react";

const Theme = createContext({
  title: "Low-carbon technologies projects",
  diclaimer: {
    label: "",
    href: "",
  },
});

export default Theme;
